import React from "react"
import { CadasBannerFornecedorContextProvider } from "./context/CadasBannerFornecedorContextProvider"
import { CadastroBannerFornecedor } from "./CadastroBannerFornecedor"

export function Index() {
    return (
        <CadasBannerFornecedorContextProvider>
            <CadastroBannerFornecedor />
        </CadasBannerFornecedorContextProvider>
    )
}
